<p-avatar [shape]="shape" [size]="size" [image]="image" class="phone:ml-2 rounded-lg" />